import classNames from "classnames";
import React, { ReactElement } from "react";
import styles from "./ShowAllTags.module.scss";
import { ArrowDownIcon } from "@kursk/components/ui/icons";

interface IProps {
  toggle: () => void;
  className?: string;
  isOpen: boolean;
}

export const ShowAllTags = ({ toggle, className, isOpen }: IProps): ReactElement => {
  const style = {
    marginRight: 0,
    marginLeft: 'auto'
  }
  return (
    <div className={classNames(styles.wrapper, className && className)} style={style} onClick={toggle}>
      <div className={classNames([styles.title, isOpen && styles.open])}>
        <span>
          {isOpen ? 'скрыть' : 'ещё'}
        </span>
        <ArrowDownIcon/>
      </div>
    </div>
  )
}
